import { useTranslation } from "react-i18next";
import Download from "../../../../components/Files/downloadDocuments";
import FileService from "../../../../services/FileService";
import moment from "moment";
import DeleteDocument from "../DeleteDocument";
import IconExport from "../../../../layout/others/icon_export.svg";
import { toast } from "react-toastify";

export function CVDocumentLine({
  docs,
  deleteCallBack,
  interviewId,
  disabled,
  refreshDocuments
}) {
  const { t } = useTranslation();
  const handleDownload = (documentId) => {
    FileService.DownloadFileBase64(`vitae/file/${documentId}`, true);
  };

  const handleConvertToDocOnline = (documentId) => {
    const formData = {
      interviewId: interviewId,
      fileId: documentId
    };
    FileService.convertToDocOnline(formData).then(() => {
      refreshDocuments();

      if (documentId === undefined) {
        toast.success(t("DocOnline create successfully"));
      } else {
        toast.error(t("An unexpected error occured"));
      }
    });
  };

  return (
    <>
      {docs &&
        docs.map((document) => (
          <tr>
            <td
              className="languages"
              onClick={() => handleDownload(document.id)}
            >
              {document.language}
            </td>
            <td
              className="description"
              onClick={() => handleDownload(document.id)}
            >
              {document.description}
            </td>
            <td
              className="updated-date"
              onClick={() => handleDownload(document.id)}
            >
              {moment(document.updateAt).format("DD-MM-YYYY")}
            </td>
            {!disabled && (
              <td className="actions d-flex">
                <Download
                  url={`vitae/file/${document.id}`}
                  fileName={document.description}
                />
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConvertToDocOnline(document.id);
                  }}
                  className="action-button"
                  title={t("Convert to DocOnline")}
                >
                  <img
                    src={IconExport}
                    alt="convert to doconline"
                    width="18px"
                    height="22px"
                    marginTop="-4px"
                  />
                </button>
                <DeleteDocument
                  documentId={document.id}
                  interviewId={interviewId}
                  deleteCallBack={deleteCallBack}
                />
              </td>
            )}
          </tr>
        ))}
      {(!docs || (docs && docs.length === 0)) && (
        <tr>
          <td colSpan="4" className="text-center">
            {t("No files added")}
          </td>
        </tr>
      )}
    </>
  );
}
